<!--
   Created by qing on 2020/12/29
   Des:
-->
<template>

  <ConfigContainer
    :isPhone="isPhone"
    :value="current"
    v-loading="current.isLoad"
    :type="type">
    <template v-if="!current.isLoad">
      <div class="apps-config-container" v-if="current.value && current.value.length">
        <template v-if="current.showType === TODO_SHOW_TYPE__WIDE">
          <div
            class="app-item"
            :style="itemStyle"
            v-for="app in current.value"
            :key="app.appId"
            @click="onClickApp(app)">
            <div
              class="icon menu-icon"
              :style="{backgroundColor: app.iconColor, width: isPhone ? '40px': '60px', height: isPhone ? '40px' : '60px'}">
              <i
                v-if="app.appIconType === 'SYSTEM'"
                class="app-icon"
                :class="app.appIcon"
                :style="{color: !app.iconColor || app.iconColor === '#ffffff' ? '#333333' : '#ffffff', fontSize: isPhone ? '20px' : '40px'}"
              ></i>
              <img
                v-if="app.appIconType === 'CUSTOM'"
                style="height: 60px; width: 60px; object-fit: cover; border-radius: 10px; background-color: #ffffff;"
                :style="iconStyle"
                :src="app.appIcon"
                alt="">
            </div>

            <div class="maintain-tag" v-if="app.maintainFlag === 'YES'">
              维护中
            </div>
            <div class="text" :style="textStyle">
              {{app.appName}}
            </div>
          </div>
        </template>

        <div v-else class="app-item-ver-container">
          <div
            class="app-item-ver"
            v-for="app in current.value"
            :key="app.appId"
            @click="onClickApp(app)">
            <div
              class="icon menu-icon"
              :style="{backgroundColor: app.iconColor}">
              <i
                v-if="app.appIconType === 'SYSTEM'"
                class="app-icon"
                :class="app.appIcon"
                :style="{color: !app.iconColor || app.iconColor === '#ffffff' ? '#333333' : '#ffffff'}"
              ></i>
              <img
                v-if="app.appIconType === 'CUSTOM'"
                style="height: 24px; width: 24px; object-fit: cover; background-color: #ffffff;"
                :src="app.appIcon"
                alt="">
            </div>
            <div class="text">
              {{app.appName}}
            </div>
          </div>
        </div>
      </div>
      <div class="apps-config-empty-container" v-else>
        <img :src="`${$BASE_PATH}/fetch/image?id=295283688126545920.png`" alt="">
        {{'暂无应用,请联系管理员配置'}}
        <van-button
          type="primary"
          class="template-btn"
          size="small"
          style="width: 40%;"
          @click="onclickTemplate">
          去应用中心体验
        </van-button>
      </div>
    </template>
  </ConfigContainer>
</template>

<script>
  import ConfigContainer from './common/ConfigContainer'
  import AppsConfig from "../instances/AppsConfig";
  import {TODO_SHOW_TYPE__WIDE} from "../type";

  export default {
    props: {
      value: Object,
      type: Number,
      isPhone: {
        type: Boolean,
        default: false
      }
    },
    components: {
      ConfigContainer
    },
    data() {
      return {
        TODO_SHOW_TYPE__WIDE,
        current: this.value,
      }
    },
    created() {
    },
    computed: {
      isWxWork() {
        return this.$store.getters.deviceType.env === 'wxwork'
      },
      isAdmin() {
        const adminInfo = this.$store.getters.adminInfo
        return adminInfo && (adminInfo.creator || adminInfo.topAdmin)
      },
      itemStyle() {
        if (this.isPhone) {
          return {
            width: 'calc((100vw - 40px) / 4)',
            height: '100px'
          }
        }
      },
      iconStyle() {
        if (this.isPhone) {
          return {
            width: '40px',
            height: '40px'
          }
        }
      },
      textStyle() {

        if (this.isPhone) {
          return {
            fontSize: '12px'
          }
        }
      }
    },
    methods: {
      onClickApp(app) {
        this.$store.commit('UPDATE__APP', app)
        this.$router.push({
          name: 'appHome',
          query: {
            appId: app.appId,
            appName: app.appName
          }
        })
      },

      onclickTemplate() {
        const toast = this.$toast.loading({message: '加载中...'})
        this.$store.dispatch('reqNodeSave', {
          userId: this.$store.getters.userId,
          userInfo: this.$store.getters.userInfo,
          company: this.$store.getters.company,
          token: this.$store.state.token,
        })
          .then(res => {
            this.$router.push({
              name: 'templateList',
              query: {
                key: res.nodeKey
              }
            })
          })
          .catch(err => {
            console.error(err)
          })
          .finally(() => {
            toast.clear()
          })
      },
    }
  }
</script>

<style lang="less">
  .apps-config-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    padding: 8px;

    .app-item {
      position: relative;
      left: 0;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;

      .icon {
        width: 60px;
        height: 60px;
        border-radius: 10px;
        border: 1px solid #e6e6e6;
        box-shadow: 0 8px 10px 0 rgba(68, 137, 255, 0.14);
        transition: all 0.3s;

        .app-icon {
          font-size: 40px;
          color: #ffffff;
        }
      }

      .menu-icon {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .text {
        margin-top: 12px;
        line-height: 22px;
        font-size: 16px;
        color: #333333;
        width: 100%;
        display: -webkit-box;
        text-align: center;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        white-space: normal;
        word-break: break-word;
      }

      .maintain-tag {
        position: absolute;
        top: -5px;
        right: -5px;
        line-height: 20px;
        padding: 0 5px;
        background-color: #6ca2ff;
        font-size: 12px;
        color: #ffffff;
        border-radius: 10px;
        transition: all 0.3s;
        border: 2px solid #ffffff;
      }

      &:hover {

        .icon {
          transform: translateY(-10px);
          box-shadow: 0 10px 14px 0 rgba(68, 137, 255, 0.14);

        }
      }
    }


    .app-item-ver-container {
      width: 100%;
      height: 100%;
      display: block;
      background-color: #fff;
      border-radius: 6px;

      .app-item-ver {
        width: 100%;
        height: 40px;
        margin: 0 0 4px;
        padding: 0 12px;
        position: relative;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        cursor: pointer;
        display: flex;

        .icon {
          width: 24px;
          height: 24px;
          border-radius: 4px;
          border: 1px solid #e6e6e6;
          display: flex;
          justify-content: center;
          align-items: center;

          .app-icon {
            font-size: 20px;
            color: #ffffff;
          }
        }

        .text {
          margin-left: 12px;
          line-height: 22px;
          font-size: 14px;
          color: #333333;
          width: calc(100% - 40px);
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-wrap: break-word;
        }

        &:hover {
          border-radius: 6px;
          background: #f4f6f9;
        }
      }
    }
  }

  .apps-config-empty-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      height: 140px;
      margin-bottom: 20px;
    }

    p {
      color: #5d616f;
      margin: 0;
    }

    a {
      color: #73a5da;
      cursor: pointer;
      outline: 0;
      text-decoration: none;
      font-size: 14px;
      margin-left: 10px;
    }

    > .el-button {
      margin-top: 20px;
      border-color: #E56833;
      color: #E56833;
      background-color: #fff;
    }
  }
</style>
